"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseIUpsertQuoteBody = void 0;
const iclient_data_entity_1 = require("./iclient-data-entity");
const iupsert_quote_data_1 = require("./iupsert-quote-data");
function parseIUpsertQuoteBody(data) {
    if (data.upsertQuote !== null && typeof data.upsertQuote === 'object')
        data.upsertQuote = (0, iupsert_quote_data_1.parseIUpsertQuoteData)(data.upsertQuote);
    if (data.newClient !== null && typeof data.newClient === 'object')
        data.newClient = (0, iclient_data_entity_1.parseIClientDataEntity)(data.newClient);
    return data;
}
exports.parseIUpsertQuoteBody = parseIUpsertQuoteBody;
